import { NepaliDatePicker } from 'nepali-datepicker-reactjs';
import { useState } from 'react';
import 'nepali-datepicker-reactjs/dist/index.css';
import { BsCalendar4Week } from 'react-icons/bs';
import styled from 'styled-components';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';

const StyledDatePickerNepali = styled.div`
  position: relative;
  .form-control {
    background: white;
    cursor: pointer;
  }
`;
const IconHolder = styled.span`
  position: absolute;
  top: 20%;
  right: 3%;
  pointer-events: none;
`;
function DatePickerNepali({ register, id, defaultValue, onChange, validation }) {
  const local = useSelector((state) => state.local.local);

  const langChecker = () => {
    if (local === 'ne') {
      setLang('ne');
    } else {
      setLang('en');
    }
  };
  const [lang, setLang] = useState(() => {
    if (local === 'ne') {
      return 'ne';
    } else {
      return 'en';
    }
  });

  useEffect(() => {
    langChecker();
  }, [local]);

  return (
    <StyledDatePickerNepali>
      <NepaliDatePicker
        inputClassName="form-control"
        className=""
        value={defaultValue || ''}
        onChange={onChange}
        options={{ calenderLocale: lang, valueLocale: 'en' }}
      />
      <IconHolder>
        <BsCalendar4Week fontSize={20} />
      </IconHolder>
      <input type="text" {...register(id, validation)} hidden readOnly />
    </StyledDatePickerNepali>
  );
}

export default DatePickerNepali;
